module.exports = __webpack_public_path__ + "media/images/dogs/chocolate-toxic-calculator-what-factors-determine-the-level-of-toxicity.jpg";